import { CreateService, CRUDServiceInterface } from '@/services/service';
import APIBuilder from '@quangphuc/frontend-api-builder';
import { SurveyQuestionResultSuccessEntity } from '@/entities/survey-question-result-success.entity';

export default class SurveyQuestionResultSuccessService
  extends CreateService<SurveyQuestionResultSuccessEntity>(
    'survey-question-result-success',
  )
  implements CRUDServiceInterface<SurveyQuestionResultSuccessEntity>
{
  async check(): Promise<SurveyQuestionResultSuccessEntity> {
    const { data } =
      await APIBuilder.axios.get<SurveyQuestionResultSuccessEntity>(
        `${this.apiBuilder.$endpoint}/check`,
      );
    return data;
  }
}
